import { Divider, Flex, Grid, GridItem, Typography } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const StyledMainImageContainer = styled(GridItem) `
  position: relative;

  img,
  button {
    height: 100%;
    width: 100%;
  }

  img {
    border-radius: ${({ theme }) => theme.borderRadius[100]};
    width: 100%;
  }

  ${({ theme }) => theme.breakpoint.minWidth('lg')} {
    overflow: auto;
    contain: size;
  }
`;
export const FullWidthDivider = styled(Divider) `
  position: absolute;
  left: 0;
  right: 0;
`;
export const FactContainer = styled.div `
  position: absolute;
  border-radius: ${({ theme }) => theme.borderRadius[100]};
  z-index: 1;
  bottom: ${({ theme }) => theme.spacing[600]};
  left: ${({ theme }) => theme.spacing[600]};
  background-color: ${({ theme }) => theme.color.background.primary};
  padding: ${({ theme }) => theme.spacing[600]};
`;
export const VideoIconContainer = styled.div `
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);

  svg {
    width: 4rem;
    height: 4rem;

    ${({ theme }) => theme.breakpoint.minWidth('md')} {
      width: 6.4rem;
      height: 6.4rem;
    }
  }
`;
export const MobileEntrance = styled(Grid) `
  text-decoration: none;
`;
export const MobileImageContainer = styled(GridItem) `
  img {
    aspect-ratio: 16/9;
    max-width: 100%;
    height: auto;
    background-color: ${({ theme }) => theme.color.background.interactiveHovered};
  }
`;
export const QuestionnaireContainer = styled(Flex) `
  border: ${({ theme }) => theme.borderWidth[25]} solid
    ${({ theme }) => theme.color.border.interactiveBase};
  border-radius: ${({ theme }) => theme.borderRadius[100]};
  height: 100%;
`;
export const QuestionnaireImageContainer = styled(GridItem) `
  position: relative;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
  }
`;
export const QuestionnaireTitle = styled(Typography) `
  line-height: ${({ theme }) => theme.typography.lineHeight[600]};
  font-size: ${({ theme }) => theme.typography.fontSize['4xl']};
  font-weight: ${({ theme }) => theme.typography.fontWeight.dobraSlab.medium};
  font-family: DobraSlabMedium, serif;
  color: ${({ theme }) => theme.color.font.interactiveBase};
`;
//# sourceMappingURL=ImageEntrances.styled.js.map